import store from "../store/store";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import getEnv from "@/utils/env";

const firebaseConfig = {
  apiKey: getEnv("VUE_APP_FCM_API_KEY"),
  authDomain: getEnv("VUE_APP_FCM_AUTH_DOMAIN"),
  projectId: getEnv("VUE_APP_FCM_PROJECT_ID"),
  storageBucket: getEnv("VUE_APP_FCM_STORAGE_BUCKET"),
  messagingSenderId: getEnv("VUE_APP_FCM_SENDER_ID"),
  appId: getEnv("VUE_APP_FCM_APP_ID"),
  measurementId: getEnv("VUE_APP_FCM_MEASUREMENT_ID"),
};

const app = initializeApp(firebaseConfig);
let messaging;

try {
  messaging = getMessaging(app);
} catch (ex) {
  console.error("FCM: Error initializing messaging instance");
}

export const initializeFCM = () => {
  if (!("Notification" in window)) {
    console.error("FCM: Notifications not supported in browser");
    store.commit("updateFcmToken", { value: { status: "fail", token: null } });
    return;
  }

  if (!app || !messaging) {
    console.error("FCM: Firebase app or messaging instance not supported");
    store.commit("updateFcmToken", { value: { status: "fail", token: null } });
    return;
  }

  if (Notification.permission === "denied") {
    console.error("FCM: Notifications permission denied by user");
    store.commit("updateFcmToken", { value: { status: "fail", token: null } });
    return;
  }

  if (!("serviceWorker" in navigator)) {
    console.error("SerivceWorkers not supported in browser");
    return;
  }

  store.commit("updateFcmToken", {
    value: { status: "loading", token: null },
  });

  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      // Register firebase service worker before retrieving token
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          navigator.serviceWorker.ready.then(() => {
            getToken(messaging, {
              vapidKey: getEnv("VUE_APP_FCM_VAPID_KEY"),
              serviceWorkerRegistration: registration,
            })
              .then((token) => {
                console.log("FCM: token: ", token);
                if (token) {
                  // Store FCM Token into vuex
                  store.commit("updateFcmToken", {
                    value: { status: "success", token: token },
                  });

                  // Handle message events when app is in foreground
                  onMessage(messaging, (payload) => {
                    console.log(
                      "FCM: Received push notification while on foreground"
                    );
                    store.dispatch("addPushNotification", {
                      newNotification: payload,
                    });
                  });

                  // Handle message events from service worker when app is in background
                  navigator.serviceWorker.addEventListener(
                    "message",
                    (event) => {
                      if (
                        event.data &&
                        event.data.type === "NEW_NOTIFICATION"
                      ) {
                        console.log(
                          "FCM: Received push notification from SW while on background"
                        );
                        const payload = event.data.payload;

                        // Dispatch a Vuex action with the payload
                        store.dispatch("addPushNotification", {
                          newNotification: payload,
                        });
                      }
                    }
                  );
                } else {
                  console.error("FCM: Failed to get FCM Token");
                  store.commit("updateFcmToken", {
                    value: { status: "fail", token: null },
                  });
                }
              })
              .catch((error) => {
                console.error("FCM: Error retrieving FCM Token: ", error);
                store.commit("updateFcmToken", {
                  value: { status: "fail", token: null },
                });
              });
          });
        });
    } else {
      console.error("FCM: Notification permission declined");
      store.commit("updateFcmToken", {
        value: { status: "fail", token: null },
      });
    }
  });
};

// Initial call
initializeFCM();
